import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikRadioGroup} from '@flexinet/ui-components';

// FNP-607: the channel is the only filter and is REQUIRED (it is the
// channel-runStartedAt-index partition key). Rendered as a radio group (not a
// select) — a small fixed set of mutually-exclusive options, always exactly one
// selected, no clear/empty state.
const channelOptions = [
    {value: 'STRIPE', label: 'Stripe'},
    {value: 'AWS_MARKETPLACE', label: 'AWS Marketplace'},
    {value: 'INTERNAL', label: 'Internal'},
];

export const FilterFormComponent = () => {
    return (
        <Stack gap='md' my='md'>
            <Field
                name='channel'
                label='Channel'
                description='Reports are listed per channel; a channel is always selected.'
                data={channelOptions}
                direction='vertical'
                component={FormikRadioGroup}
            />
        </Stack>
    );
};
